module.exports = __webpack_public_path__ + "img/themeisle.a71e713f.svg";